// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../modules/auth/store/actions';
import { GlobalState, initialState } from './state';

/**
 * This reducer is for store data using actions.
 * For global data store purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially create ruducer with few actions
 */
export function reducer(state = initialState, action: Actions | AuthActions): GlobalState {
  switch (action.type) {
    // POPUP_NOTIFICATION
    case ActionTypes.POPUP_NOTIFICATION: {
      return {
        ...state,
        error: null,
        popupNotification: action.popupNotification,
      };
    }
    // POPUP_NOTIFICATION_CALLBACK
    case ActionTypes.POPUP_NOTIFICATION_CALLBACK: {
      return {
        ...state,
        error: null,
        popupNotificationCallback: action.popupNotification,
      };
    }
    // FAILURE
    case ActionTypes.FAILURE: {
      return {
        ...state,
        error: action.payload.error,
      };
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      console.log('logout')
      return initialState;
    }
    // DEFAULT
    default:
      return state;
  }
}
